<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="categoryOperate">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="pageNum"
          @current-change="pageChange"
          :total="totalNum"
          v-if="paginationShow"
        ></el-pagination>
      </div>
      <div class="categoryTable">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          style="width: 100%"
          border
        >
          <el-table-column prop="id" label="技师Id" width="70" />
          <el-table-column prop="photo" label="技师形象图" width="120">
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.photo"
                :fit="fit"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="技师姓名" width="160" />
          <el-table-column prop="phone" label="联系电话" width="160" />
          <el-table-column prop="categoryId" label="技师分类" width="120">
            <template slot-scope="scope">
              <span>{{ getType(scope.row.categoryId) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="detailed" label="详细地址" width="160">
            <template slot-scope="scope">
              <span>{{ getAddress(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="intro" label="技师个人简介" width="160" />
          <el-table-column label="操作" width="300" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleUpload(scope.$index, scope.row)"
                >编辑技师形象图</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="handleDelete(scope.$index, scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="编辑技师形象图"
        :visible.sync="addDialogVisible"
        width="40%"
        center
        :append-to-body="true"
      >
        <el-form :label-position="left" label-width="100px">
          <el-form-item label="技师形象图">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_uploadImage()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="deleteDialogVisible"
        width="20%"
        :append-to-body="true"
        center
      >
        <span>确定要删除当前技师嘛？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteCategory()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getAllTechnician, //获取列表的接口
  getAllTechnicianCategory, // 门店分类改成技师分类
  uploadFile1,
  uploadTechnicianImage,
  deleteTechnician
} from "api/request";
import { ERR_OK } from "api/config";
import { loadingInstance, Error } from "common/js/util";

export default {
  components: {
    MSidebar,
    MHeader
  },
  data() {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      fit: null,
      fileList: [],
      left: null,
      paginationShow: false,
      addDialogVisible: false,
      list: [],
      storeTypeList: [], // jishi类型列表
      multipleSelection: [],
      deleteDialogVisible: false,
      controlData: {},
      imageUrl: null,
      thisStore: {}
    };
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this.getStoreType(); // 这里改成技师分类
      this._getList();
    }
  },
  methods: {
    //详细地址里面的和分类一样不太清除如何使用
    getAddress(row) {
      return row.detailed ? row.detailed : "暂无地址，请维护";
    },
    // 分类里面的具体是咋用的不太清楚
    getType(categoryId) {
      const desc = (records, targetId) => {
    for (let i = 0; i < records.length; i++) {
      const { umTechnicianCategoryVos } = records[i];
      if (umTechnicianCategoryVos) {
        const result = umTechnicianCategoryVos.find(child => child.id === targetId);
        if (result) {
          return result;
        } else {
          const nestedResult = desc(umTechnicianCategoryVos, targetId);
          if (nestedResult) {
            return nestedResult;
          }
        }
      }
    }
    return null;
  };
      const res = desc(this.storeTypeList, categoryId);
      return res ? res.name : "暂无分类";
      
    },
    //编辑形象图
    handleUpload(index, row) {
      this.addDialogVisible = true;
      this.controlData = this.list[index];
    },
    // 形象图里面的编辑上传
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 301);
      uploadFile1(form).then(res => {
        if (res.status === ERR_OK) {
          this.imageUrl = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // 编辑形象图的确定按钮
    _uploadImage() {
      if (!this.imageUrl) {
        alert("请上传形象图后再操作！");
        return;
      }
      let param = {
        id: this.controlData.id,
        image: this.imageUrl
      };
      loadingInstance(Loading);
      uploadTechnicianImage(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.controlData = null;
          this.imageUrl = null;
          this.addDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 点击分页
    pageChange(val) {
      this.pageNum = val;
      this.categoryDatas = [];
      this._getList();
    },
    // 门店分类        这里改成技师分类
    getStoreType() {
      loadingInstance(Loading);
      getAllTechnicianCategory().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.storeTypeList = res.data.records;
        } else {
          Error(this, res);
        }
      });
    },
    // 点删除按钮列表
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.controlData = this.list[index];
    },
    // 点确定删除按钮
    _deleteCategory() {
      let param = {
        userId: this.controlData.id
      };
      loadingInstance(Loading);
      deleteTechnician(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    // 获取列表
    _getList() {
      let param = {
        current: this.pageNum,
        size: this.pageSize
      };
      loadingInstance(Loading);
      getAllTechnician(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.list = res.data;
          this.totalNum = res.data.total;
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res);
        }
      });
    }
  }
};
</script>
<style scoped>
.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/teache/teacherList.vue